<div class="interest-register-page w-full max-w-5xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px] flex flex-row">
        <button mat-button type="button" (click)="goToAssistsOverview()" [matTooltip]="'Til baka í yfirlit'">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
        </button>

        <div class="content-center">
            <h2 class="!mt-0 !mb-0">Hagsmunaskrá</h2>
            <div class="mt-1 text-sm text-secondary">
                Skráning hagsmunaárekstra, gjafa, boðsferða, atvinnuþátttöku, stjórnarsetu og viðskipta með fjármálagerninga.
            </div>
        </div>
    </div>

    <span class="separator-line block"></span>

    <section class="mt-8 grid grid-cols-1 gap-4">
        @for (entryType of entryTypes; track entryType.type) {
            <app-interest-register-entry-type-card
                [config]="entryType"
                (selected)="selectEntryType($event)"
            ></app-interest-register-entry-type-card>
        }

        <app-interest-register-entry-type-card
            [config]="myEntriesCard"
            (selected)="goToMyEntries()"
        ></app-interest-register-entry-type-card>

        @if (canViewAllEntries) {
            <app-interest-register-entry-type-card
                [config]="allEntriesCard"
                (selected)="goToAllEntries()"
            ></app-interest-register-entry-type-card>
        }
    </section>

    <section class="interest-register-info mt-8">
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:shield-check'"></mat-icon>
        <div>
            Skráningar geta innihaldið viðkvæmar upplýsingar og eru aðeins aðgengilegar þér og þeim sem hafa sérstakan aðgang að
            Hagsmunaskrá.
        </div>
    </section>
</div>
